import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=ec4d2052&"
import script from "./accountList.vue?vue&type=script&lang=js&"
export * from "./accountList.vue?vue&type=script&lang=js&"
import style0 from "./accountList.vue?vue&type=style&index=0&id=ec4d2052&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports